"use client";

import { memo } from "react";
import {
  AdvancedChart,
  MiniChart,
  MiniChartWidgetProps,
} from "react-tradingview-embed";

const MobileTradingViewChart = memo(
  ({
    baseCurrency,
    quoteCurrency,
  }: {
    baseCurrency: string;
    quoteCurrency: string;
  }) => (
    <MiniChart
      widgetProps={{
        locale: "en",
        symbol: `BINANCE:${baseCurrency}${quoteCurrency}`,
        width: "100%",
        height: "100%",
        autosize: true,
        dateRange: "12M",
      }}
    />
  ),
);
MobileTradingViewChart.displayName = "TradingViewAdvancedChart";

export default MobileTradingViewChart;
